import React from 'react'
import Helmet from 'react-helmet'

import data from '../../data/digital-realities'
import SlideshowFooter from '../../components/SlideshowFooter'

let prev = '/digital-realities/ar_colony-square';
let next = '/digital-realities/what-is-ar';

let sliderImages = data[0].slideshow.map( (img, idx) => {
    return(
        <div key={`image-${idx}`} >
            <img src={img} alt=""/>
        </div>
    )
});

const DigitalRealities = (props) => (
    <div id="digital-reality-landing">
        <Helmet>
            <title>IMBIBE - Digital Realities: What is Virtual Reality?</title>
            <meta name="description" content="What is Virtual Reality?" />
        </Helmet>

        <img src="http://dev.imbibe.info/images/vr_what-is-vr/hero.jpg" />

        <div id="main">
            <section id="one">
                <div className="inner">
                    <h1>What is VR?</h1>
                    <p>Officially, Virtual Reality is “the computer-generated simulation of a three-dimensional image or environment that can be interacted with in a seemingly real or physical way by a person using special electronic equipment, such as a helmet with a screen inside or gloves fitted with sensors.”</p>
                    <p>Virtual Reality uses a set of video goggles and, optionally, audio headphones to present an experience unique to the user and without limitation from the real world.  "Virtual Reality" is also the catch-all term for anything related to a virtual experience.</p>
                    {/*<ul className="actions">*/}
                        {/*<li><a href="#" className="button special small">New to VR? Learn more</a></li>*/}
                    {/*</ul>*/}
                </div>
                {sliderImages}
            </section>
        </div>

        <SlideshowFooter vr prev={prev} next={next} />

    </div>
)

export default DigitalRealities


// WEBPACK FOOTER //
// ./src/pages/digital-realities/what-is-vr.js